import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "h-full flex flex-col justify-between mt-5 gap-3 pb-5 mb-10" }
const _hoisted_2 = { class: "flex gap-2 items-center pb-1 border-b border-secondary" }
const _hoisted_3 = { class: "py-2 text-3xl font-bold text-gray-700" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "flex flex-col gap-10 mt-10 relative" }
const _hoisted_6 = { class: "flex flex-col md:flex-row gap-5" }
const _hoisted_7 = { class: "w-full md:w-1/2" }
const _hoisted_8 = { class: "flex gap-5 flex-col mt-3" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "w-full md:w-1/2" }
const _hoisted_11 = { class: "flex items-center mt-3" }
const _hoisted_12 = { class: "flex flex-col gap-3 mt-5" }
const _hoisted_13 = { class: "text-primary" }
const _hoisted_14 = { class: "text-primary" }
const _hoisted_15 = { class: "mt-auto" }
const _hoisted_16 = ["disabled"]

import { useMortality } from "@/composables/tasks/mortality-check/useMortality";
import { onMounted, ref, watch, computed } from "vue";
import FooterActions from "@/components/v2/Tasks/Vaccination/Buttons/ActionButtons/FooterActions.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'GroupView',
  setup(__props) {

const { activeTank, activeGroup, navigateToTankView, updateGroupMortalityData } = useMortality();
const mortalityReasons = ["Dead", "EHE"];

const quantity = ref(1);
const selectedReason = ref("");
const comment = ref("");

const totalFishCount = computed(() =>
    activeGroup.value?.amountInTank || activeGroup.value?.count || 0
);

const totalMortality = computed(() => {
    if (!activeGroup.value?.progressData) return 0;

    if (Array.isArray(activeGroup.value.progressData)) {
        return activeGroup.value.progressData.reduce(
            (acc, item) => acc + (item.quantity || 0), 0
        );
    } else if (typeof activeGroup.value.progressData === 'object') {
        return activeGroup.value.progressData.quantity || 0;
    }

    return 0;
});

const mortalityRate = computed(() => {
    if (totalFishCount.value === 0) return "0.00";
    const rate = (totalMortality.value / (totalFishCount.value + totalMortality.value)) * 100;
    return rate.toFixed(2);
});

const increaseQuantity = () => quantity.value++;
const decreaseQuantity = () => { if (quantity.value > 1) quantity.value--; };
const handleReason = (reason: string) => selectedReason.value = reason;

const getLatestProgressEntry = (progressData: unknown): {
    quantity?: number;
    reason?: string;
    comment?: string;
} | null => {
    if (!progressData) return null;

    if (Array.isArray(progressData)) {
        if (progressData.length === 0) return null;
        return progressData[progressData.length - 1] as {
            quantity?: number;
            reason?: string;
            comment?: string;
        };
    }

    if (typeof progressData === "object") {
        return progressData as {
            quantity?: number;
            reason?: string;
            comment?: string;
        };
    }

    return null;
};

onMounted(() => {
    const latestEntry = getLatestProgressEntry(activeGroup.value?.progressData);
    if (latestEntry) {
        quantity.value = latestEntry.quantity || 1;
        selectedReason.value = latestEntry.reason || "";
        comment.value = latestEntry.comment || "";
    }
});

watch(() => activeGroup.value?.progressData, (newProgressData) => {
    const latestEntry = getLatestProgressEntry(newProgressData);
    if (latestEntry) {
        quantity.value = latestEntry.quantity || 1;
        selectedReason.value = latestEntry.reason || "";
        comment.value = latestEntry.comment || "";
    }
});

const handleSave = () => {
    if (!selectedReason.value) {
        alert('Please select a reason');
        return;
    }

    const data = {
        reason: selectedReason.value,
        quantity: quantity.value,
        comment: comment.value
    };

    updateGroupMortalityData(data);

    if (activeTank.value) {
        navigateToTankView(activeTank.value.key);
    }
};

const handleBack = () => {
    if (activeTank.value) {
        navigateToTankView(activeTank.value.key);
    }
};

const handleNoMortality = () => {
    const data = {
        reason: "No mortality",
        quantity: 0,
        comment: comment.value || "No dead fish recorded for this group"
    };

    updateGroupMortalityData(data);

    if (activeTank.value) {
        navigateToTankView(activeTank.value.key);
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(activeTank)?.label + " - " + _unref(activeGroup)?.name), 1),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(activeGroup)?.tags, (flag) => {
            return (_openBlock(), _createElementBlock("span", {
              key: flag.title,
              class: "inline-flex mr-2 text-white text-xs p-1 rounded-md font-bold",
              style: _normalizeStyle({ backgroundColor: flag.backgroundColor })
            }, _toDisplayString(flag.title), 5))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "text-gray-700 text-xl font-bold" }, "Select a reason:", -1)),
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(mortalityReasons, (reason) => {
                return _createElementVNode("button", {
                  key: reason,
                  onClick: ($event: any) => (handleReason(reason)),
                  class: _normalizeClass(["px-4 border py-2 min-w-[200px]", {
                  'bg-primary': selectedReason.value === reason,
                  'text-primary': !selectedReason.value || selectedReason.value !== reason,
                  'text-white': selectedReason.value === reason,
                  'border-gray-600': !selectedReason.value || selectedReason.value !== reason,
                }])
                }, _toDisplayString(reason), 11, _hoisted_9)
              }), 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "text-gray-700 text-xl font-bold" }, "Insert a number:", -1)),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                class: "px-4 py-2 border border-primary font-bold bg-primary text-white",
                onClick: decreaseQuantity
              }, " - "),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((quantity).value = $event)),
                class: "appearance-none w-full border border-primary px-4 py-2 text-center"
              }, null, 512), [
                [
                  _vModelText,
                  quantity.value,
                  void 0,
                  { number: true }
                ]
              ]),
              _createElementVNode("button", {
                class: "px-4 py-2 border border-primary font-bold bg-primary text-white",
                onClick: increaseQuantity
              }, " + ")
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("strong", null, [
                _cache[3] || (_cache[3] = _createTextVNode(" Current total number of fish: ")),
                _createElementVNode("span", _hoisted_13, _toDisplayString(totalFishCount.value), 1)
              ]),
              _createElementVNode("strong", null, [
                _cache[4] || (_cache[4] = _createTextVNode(" All time mortality rate: ")),
                _createElementVNode("span", _hoisted_14, _toDisplayString(mortalityRate.value) + "%", 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "text-gray-700 text-xl font-bold" }, " Leave a comment (optional): ", -1)),
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((comment).value = $event)),
            class: "w-full mt-5 p-2 border border-secondary",
            rows: "6"
          }, null, 512), [
            [_vModelText, comment.value]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(FooterActions, null, {
        start: _withCtx(() => [
          _createElementVNode("button", {
            onClick: handleBack,
            class: "w-full"
          }, " Back ")
        ]),
        middle: _withCtx(() => [
          _createElementVNode("button", {
            onClick: handleNoMortality,
            class: "w-full"
          }, " Record no mortality ")
        ]),
        end: _withCtx(() => [
          _createElementVNode("button", {
            onClick: handleSave,
            class: "w-full",
            disabled: !selectedReason.value
          }, " Save ", 8, _hoisted_16)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})